// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"c65e6686","181":"5edd2ad0","356":"f87cd0ac","434":"25ccd47c","602":"85914af8","667":"ede6fa16","905":"db707368","969":"1e3b7933","974":"a8e72653"}[chunkId] + ".chunk.js";
};